import client from "./client";

export async function loadCart() {
    const response = await client.get("/cart/load");

    return response.data;
}

export async function addCartItem(inputs: Record<string, unknown>) {
    const response = await client.post("/cart-items", inputs);

    return response.data;
}

export async function updateCartItem(
    id: number,
    inputs: Record<string, unknown>,
) {
    const response = await client.post(`/cart-items/${id}`, inputs);

    return response.data;
}

export async function rememberAbandonedCart(inputs: Record<string, unknown>) {
    const response = await client.post("/cart/remember-abandoned", inputs);

    return response.data;
}
